/**
 * Ícones de interface. Mesmo molde de `assets/items`: glob eager, nome
 * duplicado quebra na montagem, `exigir` nunca devolve vazio.
 */
const arquivos = import.meta.glob<string>('./*.svg', {
  eager: true,
  query: '?url',
  import: 'default'
});

const porNome = new Map<string, string>();

for (const [caminho, url] of Object.entries(arquivos)) {
  const nome = caminho.slice(caminho.lastIndexOf('/') + 1, -'.svg'.length);
  const existente = porNome.get(nome);
  if (existente && existente !== url) {
    throw new Error(`Ícone de UI duplicado: "${nome}" aparece em mais de um arquivo.`);
  }
  porNome.set(nome, url);
}

export function iconeUi(nome: string): string {
  const url = porNome.get(nome);
  if (!url) throw new Error(`Ícone de UI ausente em assets/ui: "${nome}.svg".`);
  return url;
}

export function nomesUi(): readonly string[] {
  return [...porNome.keys()].sort();
}
